import React from 'react';
import {
	LaboratoryRequisitionTemplate,
	useDeleteLaboratoryRequisitionTemplateMutation,
} from '../../../../../graphql/graphql';
import styles from './LaboratoryRequestTemplateListItem.module.scss';
import LinkButton from '../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../Enums/Theme.enum';
import { useDisclose } from '../../../../Modal/Hooks/useDisclose';
import LaboratoryRequestTemplateEditModal from '../LaboratoryRequestTemplateEdit/LaboratoryRequestTemplateEditModal';
import RemoveButton from '../../../../../Components/Button/RemoveButton';
import useApiClient from '../../../../Base/Hooks/useApiClient';

interface Props {
	item: LaboratoryRequisitionTemplate;
	onUpdate: (item: LaboratoryRequisitionTemplate) => void;
	onRemove: () => void;
	workplaceId: string;
}

const LaboratoryRequestTemplateListItem: React.FC<Props> = ({
	item,
	onUpdate,
	onRemove,
	workplaceId,
}) => {
	const { displayError, displayGQLError } = useApiClient();
	const { isOpen, onOpen, onClose } = useDisclose();
	const [deleteLaboratoryTemplate] =
		useDeleteLaboratoryRequisitionTemplateMutation();

	const onItemUpdate = (item: LaboratoryRequisitionTemplate) => {
		onClose();
		onUpdate(item);
	};

	const handleRemoveTemplate = async () => {
		try {
			const data = await deleteLaboratoryTemplate({
				where: { id: item.id },
			}).unwrap();
			displayGQLError(data);
			if (data.deleteLaboratoryRequisitionTemplate?.status) {
				onRemove();
			}
		} catch (e) {
			displayError(e);
		}
	};

	return (
		<>
			<div className={styles.wrapper}>
				<div className={styles.content}>
					<div className={styles.title}>{item.name}</div>
					<div className={styles.subTitle}>
						{item.laboratoryRequisition?.laboratory?.name} -{' '}
						{item.laboratoryRequisition?.name}
					</div>
				</div>
				<div className={styles.controls}>
					<LinkButton
						title='base.shared.edit'
						theme={Theme.BLUE}
						onClick={onOpen}
					/>
					<RemoveButton
						onClick={handleRemoveTemplate}
						confirmationTitle='component.laboratoryRequestTemplateListItem.removeConfirmationTitle'
						confirmationText='component.laboratoryRequestTemplateListItem.removeConfirmationText'
					/>
				</div>
			</div>
			{isOpen && (
				<LaboratoryRequestTemplateEditModal
					isOpen
					item={item}
					onUpdate={onItemUpdate}
					onClose={onClose}
					workplaceId={workplaceId}
				/>
			)}
		</>
	);
};

export default LaboratoryRequestTemplateListItem;
